export default "__VITE_ASSET__Bq1$UK_i__"